import { defineWebModule } from '@portal/web-sdk';
import { manifest } from '../manifest.js';
import { en, vi } from './translations.js';

export { NotificationBell } from './NotificationBell.js';

export const coreNotificationWebModule = defineWebModule({
  manifest,
  translations: { vi, en },
  routes: [{ path: '/notifications', component: () => import('./pages/NotificationsPage.js') }],
});
